// extracted by mini-css-extract-plugin
export default {"component":"PhoneInput_component__YQl7-"};